import * as React from "react";
import type { SVGProps } from "react";
const SvgLayers05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m21.6 11.975-9.6 4.92-9.6-4.92m19.2 4.704L12 21.6l-9.6-4.92M12 2.4l9.6 4.92-9.6 4.922L2.4 7.32z"
    />
  </svg>
);
export default SvgLayers05;
